import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

// \uBC14\uC774\uC5B4 \uC785\uAE08 \uAD00\uB9AC \uBAA8\uB2EC
// JSX text content \uB0B4 \uC774\uC2A4\uCF00\uC774\uD504\uB294 \uB9AC\uD130\uB7F4\uB85C \uB80C\uB354\uB418\uBBC0\uB85C \uBAA8\uB450 {'...'} \uC2DC \uC2EC\uBCFC \uB84C\uB3D9 \uB0B4 \uBB38\uC790\uC5F4\uB9AC\uD130\uB7F4\uB85C \uC11C\uC220
// \uBC31\uC5D4\uB4DC API: GET/POST /buyers/:id/deposits, DELETE /buyers/deposits/:depId, GET /buyers/:id/balance, POST /buyers/:id/allocate-auto

var TXT = {
  title1: '\uD83D\uDCB0',                       // 💰
  title2: ' \u2014 \uC785\uAE08 \uAD00\uB9AC',  // — 입금 관리
  close: '\u2715',                               // ×
  sumTotal: '\uCD1D \uAD6C\uB9E4\uAE08\uC561',          // 총 구매금액 (sellPrice 합)
  sumAllocated: '\uC218\uB839 \uD569\uACC4',            // 수령 합계 (실제 받은 총액)
  sumRemaining: '\uB0A8\uC740 \uC794\uAE08',            // 남은 잔금 (받아야 할 금액)
  addSection: '\u2795 \uC785\uAE08 \uCD94\uAC00', // ➕ 입금 추가
  amountLabel: '\uAE08\uC561 (\uC6D0)',           // 금액 (원)
  amountPh: '\uC608: 3,000,000',                 // 예: 3,000,000
  dateLabel: '\uC785\uAE08\uC77C',                // 입금일
  memoLabel: '\uBA54\uBAA8 (\uC120\uD0DD)',      // 메모 (선택)
  memoPh: '\uC608: 1\uCC28 \uC1A1\uAE08, SWIFT #12345', // 예: 1차 송금, SWIFT #12345
  addBtn: '\u2795 \uC785\uAE08 \uCD94\uAC00',   // ➕ 입금 추가
  saving: '\uC800\uC7A5\uC911...',               // 저장중...
  listHeader: '\uD83D\uDCDD \uC785\uAE08 \uB0B4\uC5ED', // 📝 입금 내역
  loading: '\uBD88\uB7EC\uC624\uB294 \uC911...', // 불러오는 중...
  empty: '\uC785\uAE08 \uB0B4\uC5ED \uC5C6\uC74C', // 입금 내역 없음
  count: '\uAC74, \uCD5C\uC2E0\uC21C',           // 건, 최신순
  autoBtn: '\uD83C\uDFAF \uC790\uB3D9\uBC30\uBD84', // 🎯 자동배분
  delBtn: '\uD83D\uDDD1\uFE0F',                  // 🗑️
  previewTitle: '\uBBF8\uB9AC\uBCF4\uAE30', // 미리보기
  sortLabel: '\uC6B0\uC120\uC21C\uC704', // 우선순위
  sortOldest: '\uC624\uB798\uB41C \uC21C', // 오래된 순
  sortShortage: '\uBD80\uC871 \uD070 \uC21C', // 부족 큰 순
  sortClosest: '\uC644\uB0A9 \uADFC\uC811 \uC21C', // 완납 근접 순
  sortSellPrice: '\uD310\uB9E4\uAC00 \uD070 \uC21C', // 판매가 큰 순
  sortManual: '\uC218\uB3D9 \uC815\uB82C', // 수동 정렬
  moveUp: '\u2191', // ↑
  moveDown: '\u2193', // ↓
  previewEmpty: '\uBC30\uBD84 \uAC00\uB2A5\uD55C \uCC28\uB7C9 \uC5C6\uC74C (\uBAA8\uB450 \uC644\uB0A9 \uB610\uB294 sellPrice=0)', // 배분 가능한 차량 없음
  paidMark: ' \u2713 \uC644\uB0A9',              //  ✓ 완납
  leftover: '\u26A0\uFE0F \uC794\uC561 ',        // ⚠️ 잔액
  leftoverSuffix: '\uC6D0 \u2192 \uBC14\uC774\uC5B4 \uC608\uCE58\uAE08\uC73C\uB85C \uB0A8\uC74C', // 원 → 바이어 예치금으로 남음
  confirm: '\u2714 \uD655\uC778',                // ✔ 확인
  allocating: '\uBC30\uBD84\uC911...',           // 배분중...
  cancel: '\uCDE8\uC18C',                        // 취소
  wonSuffix: '\uC6D0',                           // 원
  confirmDelete: '\uC774 \uC785\uAE08\uC744 \uC0AD\uC81C\uD560\uAE4C\uC694?\n\uC5F0\uAD00\uB41C \uCC28\uB7C9 \uBC30\uBD84\uB3C4 \uD568\uAED8 \uD574\uC81C\uB429\uB2C8\uB2E4.', // 이 입금을 삭제할까요? 연관된 차량 배분도 함께 해제됩니다.
  addedToast: '\uC785\uAE08 \uCD94\uAC00 \u2713', // 입금 추가 ✓
  amountError: '\uAE08\uC561 > 0 \uD544\uC694',  // 금액 > 0 필요
  dateError: '\uB0A0\uC9DC YYYY-MM-DD \uD544\uC694', // 날짜 YYYY-MM-DD 필요
  loadError: '\uB85C\uB4DC \uC2E4\uD328',        // 로드 실패
  serverError: '\uC11C\uBC84 \uC624\uB958',      // 서버 오류
  addFailed: '\uC2E4\uD328',                     // 실패
  delFailed: '\uC0AD\uC81C \uC2E4\uD328',        // 삭제 실패
  delDone: '\uC0AD\uC81C\uB428 (\uC601\uD5A5\uCC28\uB7C9: ', // 삭제됨 (영향차량:
  allocDone: '\uC790\uB3D9 \uBC30\uBD84 \u2713 (', // 자동 배분 ✓ (
  allocUnits: '\uB300, \uC794\uC561 ',            // 대, 잔액
  allocFailed: '\uBC30\uBD84 \uC2E4\uD328',      // 배분 실패
  rowRemaining: '\uC794\uC561 ',                  // 잔액
  rowDone: '\u2713 \uC644\uB8CC',                 // ✓ 완료
  rowCancelled: '\uD83D\uDEAB \uCDE8\uC18C',      // 🚫 취소
  rowRefunded: '\uD658\uBD88 '                    // 환불
};

function fmtKrw(won){return (won||0).toLocaleString()+TXT.wonSuffix}
function getRemaining(dep){return dep&&dep.remaining!=null?dep.remaining:(dep&&(dep.amount_krw||dep.amount))||0}

function BuyerDepositModal(props){
  var buyerId=props.buyerId;
  var buyerName=props.buyerName||'';
  var onClose=props.onClose;
  var showToast=props.showToast;

  var [deposits,setDeposits]=useState([]);
  var [balance,setBalance]=useState({totalPurchase:0,totalReceived:0,outstanding:0});
  var [loading,setLoading]=useState(false);
  var [amount,setAmount]=useState('');
  var [depositDate,setDepositDate]=useState(new Date().toISOString().slice(0,10));
  var [memo,setMemo]=useState('');
  var [saving,setSaving]=useState(false);
  var [cars,setCars]=useState([]);
  var [expandedDepId,setExpandedDepId]=useState(0);
  var [allocating,setAllocating]=useState(false);
  // \uC815\uB82C \uAE30\uC900: oldest (default FIFO) / shortage / closest / sellprice / manual
  var [sortMode,setSortMode]=useState('oldest');
  // \uC218\uB3D9 \uC815\uB82C \uC21C\uC11C (carId \uBC30\uC5F4) \u2014 sortMode==='manual'\uC778 \uACBD\uC6B0\uB9CC \uC0AC\uC6A9
  var [manualOrder,setManualOrder]=useState([]);
  // \uBAA8\uB2EC \uB2EB\uD798 / \uBC14\uC774\uC5B4 \uBCC0\uACBD \uC2DC \uC774\uC804 \uC785\uB825\uAC12/\uD3BC\uCE68 \uC0C1\uD0DC \uCD08\uAE30\uD654
  var resetAllState=function(){
    setAmount('');
    setMemo('');
    setDepositDate(new Date().toISOString().slice(0,10));
    setExpandedDepId(0);
    setSortMode('oldest');
    setManualOrder([]);
  };

  var handleClose=function(){
    resetAllState();
    if(onClose)onClose();
  };

  var load=function(){
    if(!buyerId)return;
    setLoading(true);
    Promise.all([
      authFetch(API+'/buyers/'+buyerId+'/deposits').then(function(r){return r.json()}),
      authFetch(API+'/buyers/'+buyerId+'/balance').then(function(r){return r.json()}),
      authFetch(API+'/cars?buyerId='+buyerId).then(function(r){return r.json()})
    ]).then(function(arr){
      var depRes=arr[0]; var balRes=arr[1]; var carRes=arr[2];
      setDeposits((depRes&&depRes.deposits)||[]);
      setBalance({
        totalPurchase:(balRes&&balRes.totalPurchase)||0,
        totalReceived:(balRes&&balRes.totalReceived)||0,
        outstanding:(balRes&&balRes.outstanding)||0
      });
      setCars(Array.isArray(carRes)?carRes:[]);
      setLoading(false);
    }).catch(function(){setLoading(false);showToast&&showToast(TXT.loadError,'err')});
  };

  // buyerId \uBCC0\uACBD \uC2DC \uC0C1\uD0DC \uCD08\uAE30\uD654 + \uB85C\uB4DC (\uC774\uC804 \uBC14\uC774\uC5B4 \uC794\uC5EC\uAC12 \uBC29\uC9C0)
  useEffect(function(){resetAllState();load()},[buyerId]);

  var submit=function(){
    var amt=parseInt(amount.replace(/[^0-9]/g,''),10);
    if(isNaN(amt)||amt<=0){showToast&&showToast(TXT.amountError,'err');return}
    if(!/^\d{4}-\d{2}-\d{2}$/.test(depositDate)){showToast&&showToast(TXT.dateError,'err');return}
    setSaving(true);
    authFetch(API+'/buyers/'+buyerId+'/deposits',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({amount:amt,deposit_date:depositDate,memo:memo||null})
    }).then(function(r){return r.json()}).then(function(d){
      setSaving(false);
      if(d&&d.success){
        showToast&&showToast(TXT.addedToast);
        setAmount('');setMemo('');
        load();
      }else{
        showToast&&showToast((d&&d.error)||TXT.addFailed,'err');
      }
    }).catch(function(){setSaving(false);showToast&&showToast(TXT.serverError,'err')});
  };

  var del=function(depId){
    if(!window.confirm(TXT.confirmDelete))return;
    authFetch(API+'/buyers/deposits/'+depId,{method:'DELETE'}).then(function(r){return r.json()}).then(function(d){
      if(d&&d.success){
        showToast&&showToast(TXT.delDone+(d.affectedCars||0)+')');
        load();
      }else{
        showToast&&showToast((d&&d.error)||TXT.delFailed,'err');
      }
    }).catch(function(){showToast&&showToast(TXT.serverError,'err')});
  };

  var fmtAmountInput=function(v){
    var digits=v.replace(/[^0-9]/g,'');
    if(!digits)return '';
    return parseInt(digits,10).toLocaleString();
  };

  // \uD3B8\uC5D0 \uB530\uB978 \uCC28\uB7C9 \uC815\uB82C \u2014 oldest / shortage / closest / sellprice / manual
  var sortCars=function(list,mode,order){
    var byOldest=function(a,b){
      var ra=(a.registered_at||a.createdAt||'');
      var rb=(b.registered_at||b.createdAt||'');
      if(ra!==rb)return ra<rb?-1:1;
      return (a.id||0)-(b.id||0);
    };
    var shortageOf=function(c){return (c.sellPrice||0)-(c.deposit||0)};
    if(mode==='shortage')return list.sort(function(a,b){return shortageOf(b)-shortageOf(a)});
    if(mode==='closest')return list.sort(function(a,b){return shortageOf(a)-shortageOf(b)});
    if(mode==='sellprice')return list.sort(function(a,b){return (b.sellPrice||0)-(a.sellPrice||0)});
    if(mode==='manual'&&Array.isArray(order)&&order.length){
      var idx={};order.forEach(function(id,i){idx[id]=i});
      return list.sort(function(a,b){
        var ia=idx[a.id],ib=idx[b.id];
        if(ia==null&&ib==null)return byOldest(a,b);
        if(ia==null)return 1;
        if(ib==null)return -1;
        return ia-ib;
      });
    }
    return list.sort(byOldest);
  };

  // \uD074\uB77C\uC774\uC5B8\uD2B8 \uBBF8\uB9AC\uBCF4\uAE30 (\uC11C\uBC84 \uBC30\uBD84 \uB85C\uC9C1 \uBCF5\uC81C \u2014 \uC0AC\uC6A9\uC790 \uC120\uD0DD \uC6B0\uC120\uC21C\uC704 \uC801\uC6A9)
  var previewFifo=function(depId){
    var dep=deposits.find(function(x){return x.id===depId});
    if(!dep)return {remaining:0,allocations:[]};
    var remaining=(dep.remaining!=null?dep.remaining:(dep.amount_krw||dep.amount||0));
    var candidates=cars.slice().filter(function(c){return (c.sellPrice||0)>0 && (c.payment_status||'unpaid')!=='paid'});
    var sorted=sortCars(candidates,sortMode,manualOrder);
    var list=[];
    var left=remaining;
    for(var i=0;i<sorted.length;i++){
      if(left<=0)break;
      var c=sorted[i];
      var sp=c.sellPrice||0;
      var cur=c.deposit||0;
      var shortage=sp-cur;
      if(shortage<=0)continue;
      var amt=Math.min(shortage,left);
      list.push({carId:c.id,carNo:c.carNo||('#'+c.id),sellPrice:sp,current:cur,shortage:shortage,amount:amt});
      left-=amt;
    }
    return {remaining:left,allocations:list};
  };

  // \uC218\uB3D9 \uC815\uB82C \uBAA8\uB4DC \uC9C4\uC785 \uC2DC \uD604\uC7AC \uBBF8\uC644\uB0A9 \uCC28\uB7C9 \uBAA9\uB85D\uC744 manualOrder \uCD08\uAE30\uAC12\uC73C\uB85C \uC124\uC815
  var selectSortMode=function(mode){
    if(mode==='manual'){
      var candidates=cars.slice().filter(function(c){return (c.sellPrice||0)>0 && (c.payment_status||'unpaid')!=='paid'});
      var seed=sortCars(candidates,sortMode==='manual'?'oldest':sortMode,manualOrder);
      setManualOrder(seed.map(function(c){return c.id}));
    }
    setSortMode(mode);
  };

  // \uC218\uB3D9 \uC815\uB82C: \uD56D\uBAA9 \uC704/\uC544\uB798 \uC774\uB3D9
  var moveManual=function(carId,dir){
    var arr=manualOrder.slice();
    var idx=arr.indexOf(carId);
    if(idx<0)return;
    var target=idx+dir;
    if(target<0||target>=arr.length)return;
    var tmp=arr[idx];arr[idx]=arr[target];arr[target]=tmp;
    setManualOrder(arr);
  };

  var confirmAllocate=function(depId){
    var preview=previewFifo(depId);
    var carIds=preview.allocations.map(function(a){return a.carId});
    setAllocating(true);
    authFetch(API+'/buyers/'+buyerId+'/allocate-auto',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({depositId:depId,carIds:carIds})
    }).then(function(r){return r.json()}).then(function(d){
      setAllocating(false);
      if(d&&d.success){
        var n=(d.allocated&&d.allocated.length)||0;
        showToast&&showToast(TXT.allocDone+n+TXT.allocUnits+(d.remaining||0).toLocaleString()+TXT.wonSuffix+')');
        setExpandedDepId(0);
        load();
      }else{
        showToast&&showToast((d&&d.error)||TXT.allocFailed,'err');
      }
    }).catch(function(){setAllocating(false);showToast&&showToast(TXT.serverError,'err')});
  };

  var overlay={position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:2000,display:'flex',alignItems:'center',justifyContent:'center',padding:20};
  var modal={background:'#fff',borderRadius:12,width:'100%',maxWidth:640,maxHeight:'90vh',display:'flex',flexDirection:'column',overflow:'hidden'};
  var header={padding:'16px 20px',borderBottom:'1px solid #e2e8f0',display:'flex',justifyContent:'space-between',alignItems:'center'};
  var body={padding:'16px 20px',overflowY:'auto',flex:1};
  var label={display:'block',fontSize:11,fontWeight:600,color:'#64748b',marginBottom:4,marginTop:10};
  var input={width:'100%',padding:'8px 10px',border:'1px solid #d0d5dd',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box'};

  return (
    <div style={overlay} onClick={handleClose}>
      <div style={modal} onClick={function(e){e.stopPropagation()}}>
        <div style={header}>
          <div>
            <div style={{fontSize:16,fontWeight:700,color:'#0f172a'}}>{TXT.title1 + ' ' + buyerName + TXT.title2}</div>
          </div>
          <button onClick={handleClose} style={{background:'none',border:'none',fontSize:22,cursor:'pointer',color:'#64748b'}}>{TXT.close}</button>
        </div>
        <div style={body}>
          {/* \uC794\uC561 \uC694\uC57D */}
          <div style={{display:'grid',gridTemplateColumns:'repeat(3, 1fr)',gap:10,marginBottom:16}}>
            <div style={{padding:12,background:'#f1f5f9',borderRadius:8}}>
              <div style={{fontSize:10,color:'#64748b'}}>{TXT.sumTotal}</div>
              <div style={{fontSize:16,fontWeight:700,color:'#1e293b',marginTop:4}}>{fmtKrw(balance.totalPurchase)}</div>
            </div>
            <div style={{padding:12,background:'#eff6ff',borderRadius:8}}>
              <div style={{fontSize:10,color:'#64748b'}}>{TXT.sumAllocated}</div>
              <div style={{fontSize:16,fontWeight:700,color:'#2563eb',marginTop:4}}>{fmtKrw(balance.totalReceived)}</div>
            </div>
            <div style={{padding:12,background:balance.outstanding>0?'#fef3c7':'#f0fdf4',borderRadius:8}}>
              <div style={{fontSize:10,color:'#64748b'}}>{TXT.sumRemaining}</div>
              <div style={{fontSize:16,fontWeight:700,color:balance.outstanding>0?'#d97706':'#16a34a',marginTop:4}}>{fmtKrw(balance.outstanding)}</div>
            </div>
          </div>

          {/* \uC785\uAE08 \uCD94\uAC00 \uD3FC */}
          <div style={{padding:14,background:'#f8fafc',borderRadius:10,marginBottom:16}}>
            <div style={{fontSize:13,fontWeight:700,color:'#0f172a',marginBottom:8}}>{TXT.addSection}</div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 160px',gap:10}}>
              <div>
                <label style={label}>{TXT.amountLabel}</label>
                <input style={input} value={amount} onChange={function(e){setAmount(fmtAmountInput(e.target.value))}} placeholder={TXT.amountPh}/>
              </div>
              <div>
                <label style={label}>{TXT.dateLabel}</label>
                <input type="date" style={input} value={depositDate} onChange={function(e){setDepositDate(e.target.value)}}/>
              </div>
            </div>
            <label style={label}>{TXT.memoLabel}</label>
            <input style={input} value={memo} onChange={function(e){setMemo(e.target.value)}} placeholder={TXT.memoPh}/>
            <button
              onClick={submit}
              disabled={saving}
              style={{marginTop:12,padding:'10px 20px',borderRadius:8,border:'none',background:saving?'#94a3b8':'#1B3A5C',color:'#fff',fontSize:13,fontWeight:700,cursor:saving?'default':'pointer'}}>
              {saving?TXT.saving:TXT.addBtn}
            </button>
          </div>

          {/* \uC785\uAE08 \uB0B4\uC5ED */}
          <div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
              <div style={{fontSize:13,fontWeight:700,color:'#0f172a'}}>{TXT.listHeader + ' '}<span style={{fontSize:11,color:'#64748b',fontWeight:500}}>{'(' + deposits.length + TXT.count + ')'}</span></div>
            </div>
            {loading&&<div style={{padding:16,textAlign:'center',color:'#94a3b8',fontSize:12}}>{TXT.loading}</div>}
            {!loading&&deposits.length===0&&<div style={{padding:20,textAlign:'center',color:'#94a3b8',fontSize:12,background:'#f8fafc',borderRadius:8}}>{TXT.empty}</div>}
            {!loading&&deposits.map(function(d){
              var isExpanded=expandedDepId===d.id;
              var preview=isExpanded?previewFifo(d.id):null;
              // \uC6D0\uBCF8 KRW \uAE08\uC561: KRW\uBA74 amount, \uC678\uD654\uBA74 amount \u00D7 exchange_rate
              var depOriginal=((d.currency||'KRW')==='KRW')?(d.amount||0):Math.round((d.amount||0)*(d.exchange_rate||1));
              var depCurrent=d.amount_krw!=null?d.amount_krw:depOriginal;
              var depRefunded=depOriginal-depCurrent;
              var depRemain=getRemaining(d);
              var fullyRefunded=depCurrent<=0&&depOriginal>0;
              var partiallyRefunded=depRefunded>0&&depCurrent>0;
              var fullyAllocated=!fullyRefunded&&depRemain<=0&&depCurrent>0;
              var partialAllocated=depRemain>0&&depRemain<depCurrent;
              var depTotal=depOriginal;
              return (
                <div key={d.id} style={{background:'#fff',border:'1px solid '+(isExpanded?'#1B3A5C':(fullyRefunded?'#fecaca':'#e2e8f0')),borderRadius:8,marginBottom:6,opacity:fullyRefunded?0.75:1}}>
                  <div style={{padding:'10px 12px',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:2,flexWrap:'wrap'}}>
                        <span style={{fontSize:13,fontWeight:700,color:fullyRefunded?'#94a3b8':'#1e293b',textDecoration:fullyRefunded?'line-through':'none'}}>{fmtKrw(depTotal)}</span>
                        <span style={{fontSize:11,color:'#64748b'}}>{d.deposit_date}</span>
                        {d.currency&&d.currency!=='KRW'&&<span style={{fontSize:10,color:'#64748b',background:'#f1f5f9',padding:'1px 6px',borderRadius:4}}>{d.currency + ' \u00D7 ' + d.exchange_rate}</span>}
                        {fullyRefunded&&<span style={{fontSize:11,color:'#dc2626',fontWeight:700,background:'#fee2e2',padding:'1px 8px',borderRadius:10}}>{TXT.rowCancelled}</span>}
                        {partiallyRefunded&&<span style={{fontSize:11,color:'#dc2626',fontWeight:600}}>{'(' + TXT.rowRefunded + depRefunded.toLocaleString() + TXT.wonSuffix + ')'}</span>}
                        {partialAllocated&&!fullyRefunded&&<span style={{fontSize:11,color:'#EF9F27',fontWeight:600}}>{'(' + TXT.rowRemaining + depRemain.toLocaleString() + TXT.wonSuffix + ')'}</span>}
                        {fullyAllocated&&<span style={{fontSize:11,color:'#1D9E75',fontWeight:700,background:'#f0fdf4',padding:'1px 8px',borderRadius:10}}>{TXT.rowDone}</span>}
                      </div>
                      {d.memo&&<div style={{fontSize:11,color:'#64748b',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{d.memo}</div>}
                    </div>
                    <div style={{display:'flex',gap:6,flexShrink:0}}>
                      <button onClick={function(){setExpandedDepId(isExpanded?0:d.id)}} disabled={fullyAllocated||fullyRefunded} style={{padding:'4px 10px',background:(fullyAllocated||fullyRefunded)?'#e2e8f0':(isExpanded?'#1B3A5C':'#eff6ff'),color:(fullyAllocated||fullyRefunded)?'#94a3b8':(isExpanded?'#fff':'#1d4ed8'),border:'none',borderRadius:6,fontSize:11,fontWeight:600,cursor:(fullyAllocated||fullyRefunded)?'not-allowed':'pointer',opacity:(fullyAllocated||fullyRefunded)?0.6:1}}>{TXT.autoBtn}</button>
                      <button onClick={function(){del(d.id)}} style={{padding:'4px 10px',background:'#fee2e2',color:'#dc2626',border:'none',borderRadius:6,fontSize:11,fontWeight:600,cursor:'pointer'}}>{TXT.delBtn}</button>
                    </div>
                  </div>
                  {isExpanded&&preview&&(
                    <div style={{padding:'10px 12px',borderTop:'1px solid #e2e8f0',background:'#f8fafc'}}>
                      <div style={{fontSize:11,fontWeight:700,color:'#0f172a',marginBottom:6}}>{TXT.previewTitle}</div>
                      {/* \uC815\uB82C \uAE30\uC900 \uD1A0\uAE00 */}
                      <div style={{display:'flex',flexWrap:'wrap',gap:4,marginBottom:8,alignItems:'center'}}>
                        <span style={{fontSize:10,color:'#64748b',marginRight:4}}>{TXT.sortLabel}</span>
                        {[['oldest',TXT.sortOldest],['shortage',TXT.sortShortage],['closest',TXT.sortClosest],['sellprice',TXT.sortSellPrice],['manual',TXT.sortManual]].map(function(pair){
                          var key=pair[0];var label=pair[1];
                          var active=sortMode===key;
                          return (
                            <button key={key} onClick={function(){selectSortMode(key)}} style={{padding:'3px 8px',borderRadius:12,border:'1px solid '+(active?'#1B3A5C':'#d0d5dd'),background:active?'#1B3A5C':'#fff',color:active?'#fff':'#475569',fontSize:10,fontWeight:600,cursor:'pointer'}}>{label}</button>
                          );
                        })}
                      </div>
                      {preview.allocations.length===0&&(
                        <div style={{fontSize:11,color:'#94a3b8',padding:8,textAlign:'center'}}>{TXT.previewEmpty}</div>
                      )}
                      {preview.allocations.map(function(a,idx){
                        var pct=Math.round((a.current+a.amount)/a.sellPrice*100);
                        var paid=(a.current+a.amount)>=a.sellPrice;
                        var isManual=sortMode==='manual';
                        var isFirst=idx===0;
                        var isLast=idx===preview.allocations.length-1;
                        return (
                          <div key={a.carId} style={{padding:'6px 8px',marginBottom:4,background:'#fff',borderRadius:6,border:'1px solid '+(paid?'#86efac':'#e2e8f0'),fontSize:11}}>
                            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:6}}>
                              <div style={{display:'flex',alignItems:'center',gap:4,flex:1,minWidth:0}}>
                                {isManual&&(
                                  <span style={{display:'flex',flexDirection:'column',gap:1}}>
                                    <button onClick={function(){moveManual(a.carId,-1)}} disabled={isFirst} style={{padding:'0 4px',fontSize:9,lineHeight:'10px',border:'1px solid #d0d5dd',borderRadius:3,background:isFirst?'#f1f5f9':'#fff',color:isFirst?'#cbd5e1':'#475569',cursor:isFirst?'not-allowed':'pointer'}}>{TXT.moveUp}</button>
                                    <button onClick={function(){moveManual(a.carId,1)}} disabled={isLast} style={{padding:'0 4px',fontSize:9,lineHeight:'10px',border:'1px solid #d0d5dd',borderRadius:3,background:isLast?'#f1f5f9':'#fff',color:isLast?'#cbd5e1':'#475569',cursor:isLast?'not-allowed':'pointer'}}>{TXT.moveDown}</button>
                                  </span>
                                )}
                                <span style={{fontWeight:600,color:'#1e293b'}}>{(idx+1) + '. ' + a.carNo}</span>
                              </div>
                              <span style={{fontWeight:700,color:paid?'#16a34a':'#2563eb'}}>{'+ ' + a.amount.toLocaleString() + TXT.wonSuffix}</span>
                            </div>
                            <div style={{fontSize:10,color:'#64748b',marginTop:2}}>
                              {a.current.toLocaleString() + ' \u2192 ' + (a.current+a.amount).toLocaleString() + ' / ' + a.sellPrice.toLocaleString() + TXT.wonSuffix + ' (' + pct + '%' + (paid?TXT.paidMark:'') + ')'}
                            </div>
                          </div>
                        );
                      })}
                      {preview.remaining>0&&(
                        <div style={{fontSize:11,color:'#d97706',padding:'4px 8px',background:'#fef3c7',borderRadius:4,marginTop:4}}>{TXT.leftover + preview.remaining.toLocaleString() + TXT.leftoverSuffix}</div>
                      )}
                      <div style={{display:'flex',gap:6,marginTop:8}}>
                        <button
                          onClick={function(){confirmAllocate(d.id)}}
                          disabled={allocating||preview.allocations.length===0}
                          style={{flex:1,padding:'8px 12px',borderRadius:6,border:'none',background:(allocating||preview.allocations.length===0)?'#94a3b8':'#1B3A5C',color:'#fff',fontSize:12,fontWeight:700,cursor:(allocating||preview.allocations.length===0)?'default':'pointer'}}>
                          {allocating?TXT.allocating:TXT.confirm}
                        </button>
                        <button onClick={function(){setExpandedDepId(0)}} style={{padding:'8px 12px',borderRadius:6,border:'1px solid #d0d5dd',background:'#fff',color:'#64748b',fontSize:12,fontWeight:600,cursor:'pointer'}}>{TXT.cancel}</button>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BuyerDepositModal;
